import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'
import Icon from '@mdi/react'
import { useAtom } from 'jotai'

import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { Stack } from '@/components/ui/stack'
import { docsLeftSideExpandedAtom } from '@/store/documents/DocumentsAtom'

import DropZone from '../../dropzone'
import UploadedFiles from '../uploadedFiles'
import UploadingDocuments from '../uploadingDocuments'
import UploadHeader from './components/UploadHeader/UploadHeader'

const LeftSide = () => {
    const [showSidebar, setShowSidebar] = useAtom(docsLeftSideExpandedAtom)

    const toggleSidebar = () => {
        setShowSidebar(!showSidebar)
    }
    return (
        <Box h="100%" position="relative">
            <Box
                height="100%"
                py="24px"
                pr={['0', '0', '30px']}
                pl={['0', '0', showSidebar ? '24px' : '0']}
                width="100%"
                position="relative"
            >
                <Box height="100%" width="100%" display={showSidebar ? 'block' : 'none'}>
                    <Stack height="calc(100%)" minH="300px">
                        <UploadHeader />
                        <UploadingDocuments />
                        <DropZone />
                        <UploadedFiles />
                    </Stack>
                </Box>
                <Flex
                    position="absolute"
                    top="0"
                    right="0"
                    flexDir="column"
                    height="100%"
                    justifyContent="center"
                    cursor="pointer"
                    onClick={toggleSidebar}
                    width="30px"
                    alignItems="center"
                >
                    <Icon path={showSidebar ? mdiChevronLeft : mdiChevronRight} size={1} />
                </Flex>
            </Box>
        </Box>
    )
}

export default LeftSide
